import { render, staticRenderFns } from "./crm-orders.vue?vue&type=template&id=21a322a2&scoped=true&"
import script from "./crm-orders.vue?vue&type=script&lang=js&"
export * from "./crm-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a322a2",
  null
  
)

export default component.exports